module.exports = __webpack_public_path__ + "img/deposit.a5bb84b4.svg";